import { projectsState } from './projects.state';
import { projectsActions } from './projects.actions';
import { projectsMutations } from './projects.mutations';
import { Module } from 'vuex';
import { RootState } from '@/store/store';

export default {
  namespaced: true,
  state: projectsState,
  actions: projectsActions,
  mutations: projectsMutations
} as unknown as Module<typeof projectsState, RootState>;
